import Banner02 from "./Banner02";
import Banner01 from "./Banner01";
import CountUp from "react-countup";

const Banner = () => {
  return (
    <section className="main">
      <div className="width">
        <div className="box1">
          <h2>한국 선천성 횡격막 탈장 코호트</h2>
          <h3>K-CDH, 선천성 횡격막 탈장 아이의 가족과 함께 합니다.</h3>
          <Banner01 />
        </div>
        <div className="box2">
          <Banner02 />
        </div>
        <div className="box3">
          <h2>코호트 등록현황</h2>
          <div className="num_wrap">
            <div className="num">
              <img src="/assets/img/m-icon1.png" alt="" className="mx-auto" />
              <h3>등록대상자 수</h3>
              <h4>
                <CountUp
                  start={0}
                  end={86}
                  duration={2}
                  separator=","
                  className="text-[28px] font-bold text-secondary counter h-[34px]"
                />{" "}
                명
              </h4>
            </div>
            <div className="num">
              <img src="/assets/img/m-icon2.png" alt="" className="mx-auto" />
              <h3>외래추적 대상자 수</h3>
              <h4 className="h-[34px]">
                <CountUp
                  start={0}
                  end={74}
                  duration={2}
                  separator=","
                  className="text-[28px] font-bold text-secondary counter h-[34px]"
                />{" "}
                명
              </h4>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
